/** 현재 BottomSheetContent 에서 사용중  */
export const destination = [
  {
    label: "강원",
  },
  {
    label: "경기",
  },
  {
    label: "경남",
  },
  {
    label: "경북",
  },
  {
    label: "전남",
  },
  {
    label: "전북",
  },
  {
    label: "충남",
  },
  {
    label: "충북",
  },
  {
    label: "광주",
  },
  {
    label: "대구",
  },
  {
    label: "대전",
  },
  {
    label: "부산",
  },
  {
    label: "서울",
  },
  {
    label: "울산",
  },
  {
    label: "인천",
  },
  {
    label: "세종",
  },
];
